module.exports = __webpack_public_path__ + "static/media/404.e3a06bf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/404.jpg
// module id = 1072
// module chunks = 0